module.exports = __webpack_public_path__ + "img/mes-title-bg.0ab0dbbe.png";